import { render } from "./OffCanvas.vue?vue&type=template&id=029bfde4"
import script from "./OffCanvas.vue?vue&type=script&lang=js"
export * from "./OffCanvas.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../SINTEZ/OKCU/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__